/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

/**
 * jscdk-feature-status.ts --
 *
 *      Model to store feature status,
 *      default all to false.
 */
const FeatureStatusModel = function () {
   this.status = {
      AzureConnectionRetry: false,
      DynamicPathEnabled: false
   };
   this.set = function (status) {
      for (const key in status) {
         if (this.status.hasOwnProperty(key)) {
            this.status[key] = status[key];
         }
      }
   };
   this.getStatus = function (name) {
      if (!name || !(name in this.status)) {
         return false;
      }
      return this.status[name];
   };
};

const model = new FeatureStatusModel();

export default model;
